<!-- 
	This is the new product page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
  <div>
    <div v-if="isLoading" class="loading-container">
      <a-icon type="loading" theme="outlined" class="loading-icon" />
    </div>
    <div v-if="!isLoading">

      <!-- Header Background Image -->
      <div></div>
      <!-- / Header Background Image -->


      <!-- Steps and forms -->
      <div class="mx-auto m-50" style="max-width: 1200px;">

        <!-- Steps -->
        <div class="mb-50" style="max-width: 1200px;">

          <a-steps progress-dot v-model="step">

            <a-step title="1. Recipe Creation" :disabled="true" />
            <a-step title="2. Rational" :disabled="true" />
            <a-step title="3. SDS" :disabled="true" />
            <a-step title="4. Label" :disabled="true" />
          </a-steps>

        </div>
        <!-- / Steps -->

        <!-- Steps tabs and forms -->
        <div class="mb-50">

          <!-- Step 1 : Product Information -->
          <a-card v-if="step == 0" :bordered="false" class="header-solid" :bodyStyle="{ paddingTop: 0 }"
            :headStyle="{ paddingBottom: '0' }">



            <a-form :form="form" @submit="handleSubmit" :hideRequiredMark="true">
              <a-col :span="24">
                <a-form-item class="mb-10" label="Created By" :colon="false" required>
                  <a-input v-model="createdBy" placeholder="" read-only />
                </a-form-item>
              </a-col>
              <a-row :gutter="[24]">
                <a-col :span="24">
                  <a-form-item class="mb-10" label="Customer Name" :colon="false" required>
                    <a-select v-model="customerId" placeholder="Select customer">
                      <a-select-option v-for="customer in customerData" :key="customer.id" :value="customer.id">
                        {{ customer.customerName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item class="mb-10" label="Recipe Name" :colon="false" required>
                    <a-input v-model="recipeName" placeholder="Enter recipe name" />
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item class="mb-10" label="Current Date" :colon="false" hidden>
                    <a-input :value="currentDateTime" @input="currentDateTime = $event" />
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>

            <template #title>
              <h5 class="mb-0">Recipe Creation</h5>
            </template>

            <!-- Product Information form -->
            <a-form :form="form" @submit="handleSubmit" :hideRequiredMark="true">
              <a-row :gutter="[24]">
                <a-col :span="12">
                  <a-form-item class="tags-field mb-10" label="Name" :colon="false">
                    <a-select mode="multiple" v-model="selectedTags" style="width: 100%"
                      placeholder="eg. UREA (46) BULK">
                      <a-select-option v-for="classification in classificationData" :key="classification.id"
                        :value="classification.component_Name">
                        {{ classification.component_Name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="[24]">
                <a-col :span="24">
                  <a-form-item class="mb-10" label="Selected Recipe Items (Percentage)" :colon="false">
                    <table cellpadding="5">
                      <tr v-for="value in selectedTags">
                        <td>
                          {{ getDetailsByComponentName(value).component_Name }}
                        </td>
                        <td>
                          <a-input :id="getDetailsByComponentName(value).component_Name + '-ConcentrationId'"
                            placeholder="eg. 7.4"
                            v-model="concentrations[getDetailsByComponentName(value).component_Name]"
                            @change="calculateSumOfBlend()"
                            @input="() => sanitizeAmount(getDetailsByComponentName(value).component_Name)" />
                        </td>
                        <td>
                          <a-input read-only :value="getDetailsByComponentName(value).oralCalc" />
                        </td>
                        <td>
                          <a-input read-only :value="getDetailsByComponentName(value).dermalCalc" />
                        </td>
                        <td>
                          <a-input read-only :value="getDetailsByComponentName(value).inhalationCalc" />
                        </td>
                      </tr>
                    </table>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
            <!-- <a-row :gutter="[24]">
                <a-col :span="24" v-if="selectedTags.length">
                  <h4>Totals</h4>
                </a-col>
              </a-row> -->
            <a-row :gutter="[24]" class="calculation-section">
              <a-col :span="24" v-if="selectedTags.length">
                <a-form :form="form" @submit="handleSubmit" :hideRequiredMark="true">
                  <a-row :gutter="[24]">
                    <a-col :span="6" v-if="selectedTags.length">
                      <a-form-item class="tags-field mb-10" label="Sum of blend" :colon="false" :span="3">
                        <a-input id="sumOfBlend" v-model="sumOfBlend" read-only />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6" v-if="selectedTags.length">
                      <a-form-item class="tags-field mb-10" label="ATE MIX (Oral)" :colon="false">
                        <a-input id="ateMixOral" v-model="ateMixOral" read-only />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6" v-if="selectedTags.length">
                      <a-form-item class="tags-field mb-10" label="TOTAL ATE (Oral)" :colon="false">
                        <a-input id="totalATEMixOral" v-model="totalATEMixOral" read-only />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6" v-if="selectedTags.length">
                      <a-form-item class="tags-field mb-10" label="ATE MIX (Dermal)" :colon="false">
                        <a-input id="ateMixDermal" v-model="ateMixDermal" read-only />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6" v-if="selectedTags.length">
                      <a-form-item class="tags-field mb-10" label="TOTAL ATE (Dermal)" :colon="false">
                        <a-input id="totalATEMixDermal" v-model="totalATEMixDermal" read-only />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6" v-if="selectedTags.length">
                      <a-form-item class="tags-field mb-10" label="ATE MIX (Inhalation)" :colon="false">
                        <a-input id="ateMixInhalation" v-model="ateMixInhalation" read-only />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6" v-if="selectedTags.length">
                      <a-form-item class="tags-field mb-10" label="TOTAL ATE (Inhalation)" :colon="false">
                        <a-input id="totalATEMixInhalation" v-model="totalATEMixInhalation" read-only />
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-form>
              </a-col>
            </a-row>
            <a-row :gutter="[24]">
              <a-col :span="12">
              </a-col>
              <a-col :span="12" class="text-right">
                <a-button type="primary" @click="updateRecipe(); moveStep(1)" class="px-25" :disabled="isButtonLoading"
                  :loading="isButtonLoading">NEXT</a-button>
              </a-col>
            </a-row>
          </a-card>

          <!-- Step 2 : Media -->
          <a-card v-else-if="step == 1" :bordered="false" class="header-solid"
            :headStyle="{ paddingBottom: '0' }">
            <!-- <a-row :gutter="[24]">


              <template #title>
                <h5 class="mb-0">Rational</h5>
              </template>


              <template>
                <div class="container">
                  <div class="row text-center">
                    <div class="col-md-6">
                      <a-button type="primary" @click="generateDocumentRational()" class="px-25"
                        :disabled="isButtonLoading" :loading="isButtonLoading">Generate Rational</a-button>
                    </div>
                  </div>
                </div>
              </template>
            </a-row> -->

            <a-row :gutter="[24]">
              <a-col :span="8" class="text-left">
                <a-button type="primary" @click="moveStep(-1)" class="px-25" :disabled="isButtonLoading"
                  :loading="isButtonLoading">PREV</a-button>
              </a-col>
              <a-col :span="8" style="text-align: center;">
                <a-button type="primary" @click="generateDocumentRational()" class="px-25"
                        :disabled="isButtonLoading" :loading="isButtonLoading">Generate Rational</a-button>
              </a-col>
              <a-col :span="8" class="text-right">
                <a-button type="primary" @click="moveStep(1)" class="px-25" :disabled="isButtonLoading"
                  :loading="isButtonLoading">NEXT</a-button>
              </a-col>
            </a-row>

          </a-card>

          <!-- Step 3 : Socials -->
          <a-card v-else-if="step == 2" :bordered="false" class="header-solid"
            :headStyle="{ paddingBottom: '0' }">

            <a-row :gutter="[24]">
              <a-col :span="8" class="text-left">
                <a-button type="primary" @click="moveStep(-1)" class="px-25" :disabled="isButtonLoading"
                  :loading="isButtonLoading">PREV</a-button>
              </a-col>
              <a-col :span="8" style="text-align: center;">
                <a-button type="primary" @click="generateDocumentSDS()" class="px-25"
                        :disabled="isButtonLoading" :loading="isButtonLoading">Generate SDS</a-button>
              </a-col>
              <a-col :span="8" class="text-right">
                <a-button type="primary" @click="moveStep(1)" class="px-25" :disabled="isButtonLoading"
                  :loading="isButtonLoading">NEXT</a-button>
              </a-col>
            </a-row>

          </a-card>

          <!-- Step 3 : Socials -->
          <a-card v-else-if="step == 3" :bordered="false" class="header-solid"
            :headStyle="{ paddingBottom: '0' }">

            <!-- Socials form -->

            <a-row :gutter="[24]">
              <a-col :span="8" class="text-left">
                <a-button type="primary" @click="moveStep(-1)" class="px-25" :disabled="isButtonLoading"
                  :loading="isButtonLoading">PREV</a-button>
              </a-col>
              <a-col :span="8" style="text-align: center;">
                <a-button type="primary" @click="generateDocumentLabel()" class="px-25"
                        :disabled="isButtonLoading" :loading="isButtonLoading">Generate Label</a-button>
              </a-col>
              <a-col :span="8" class="text-left">
              </a-col>
            </a-row>
          </a-card>

          <!-- Step 4 : Pricing -->
          <a-card v-else-if="step == 4" :bordered="false" class="header-solid" :bodyStyle="{ paddingTop: 0 }"
            :headStyle="{ paddingBottom: '0' }">

            <template #title>
              <h5 class="mb-0">Pricing</h5>
            </template>

            <!-- Pricing form -->
            <a-form :form="form" @submit="handleSubmit" :hideRequiredMark="true">
              <a-row :gutter="[24]">
                <a-col :span="24" :md="6">
                  <a-form-item class="mb-10" label="Price" :colon="false">
                    <a-input placeholder="99.00" />
                  </a-form-item>
                </a-col>
                <a-col :span="24" :md="8">
                  <a-form-item class="mb-10" label="Currency" :colon="false">
                    <a-select default-value="USD">
                      <a-select-option value="USD">USD</a-select-option>
                      <a-select-option value="EUR">EUR</a-select-option>
                      <a-select-option value="GBP">GBP</a-select-option>
                      <a-select-option value="INR">INR</a-select-option>
                      <a-select-option value="CNY">CNY</a-select-option>
                      <a-select-option value="BTC">BTC</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="24" :md="10">
                  <a-form-item class="mb-10" label="SKU" :colon="false">
                    <a-input placeholder="71283476591" />
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item class="tags-field mb-10" label="Tags" :colon="false">
                    <a-select mode="multiple" v-model="selectedTags" style="width: 100%" placeholder="Tags">
                      <a-select-option v-for="classification in classificationData" :key="classification.id"
                        :value="classification.component_Name" selected>
                        {{ classification.component_Name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="[24]">
                <a-col :span="12">
                  <a-button @click="moveStep(-1)" class="px-25" :disabled="isButtonLoading"
                    :loading="isButtonLoading">PREV</a-button>
                </a-col>
                <a-col :span="12" class="text-right">
                  <a-button type="primary" class="px-25" :disabled="isButtonLoading"
                    :loading="isButtonLoading">SEND</a-button>
                </a-col>
              </a-row>
            </a-form>
            <!-- / Pricing form -->

          </a-card>

        </div>
        <!-- / Steps tabs and forms -->

      </div>
      <!-- / Steps and forms -->

    </div>
  </div>
</template>

<script>

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor'

// Available tags.
//const tags = ['UREA (46) BULK', 'LAN 289', 'CAN 27', 'Calcium Carbonate', 'AMS 04 GRAN', 'MAP  BULK', "KCL GRAN BULK", "K2SO4 (SOP)", "KNO310", "BRIMSTONE", "ZN 20/ZN40", "ZnSO4", "KORREL BOOR4", "Arborite", "QDROP KS", "CaNO3", "MgNO3", "MgSO4", "Supers 1412", "Microlife", "Calcium sulfate6", "CALMAG5", "FILLER", "SELCOTE8", "MB", "CMB", "ACTIFYN", "MAP TECH", "MKP", "COPSUL", "AMFIX RD 52", "Nutrisphere", "Avail", "Green Boost", "Green Optimizer"];

const classificationData = [];

const customerData = [];

let currentURL = window.location.href;
let splitURL = currentURL.split('/');
let splitURLLength = splitURL.length;

export default {
  components: {
    quillEditor,
  },


  data() {
    return {
      id: 0,
      concentrations: {},
      // Active button for the "User Profile" card's radio button group.
      profileHeaderBtns: 'overview',
      form: this.$form.createForm(this),
      loggedInUser: '',
      currentDateTime: '',
      recipeId: null,
      recipeName: '',
      createdBy: '',
      customerId: [],
      ateMixOral: 0,
      totalATEMixOral: 0,
      ateMixDermal: 0,
      totalATEMixDermal: 0,
      ateMixInhalation: 0,
      totalATEMixInhalation: 0,
      sumOfBlend: 0,
      // Current active step.
      step: 0,
      isLoading: false,
      isButtonLoading: false,

      // Selected tags.
      selectedTags: [],

      classificationData,

      customerData,
      // Form object.
      form: this.$form.createForm(this, { name: 'newProduct' }),

      // Quill editor html content.
      quillContent: '<p>Some initial <strong>bold</strong> text</p>',

      // Quill editor options.
      quillOptions: {
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, 'link'],
            ['clean'],
          ]
        },
      }

    }
  },

  mounted() {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');

    this.currentDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;
  },

  methods: {
    sanitizeAmount(key) {
      let originalValue = this.concentrations[key];
      let sanitizedAmount = this.cleanInput(originalValue);
      this.concentrations[key] = sanitizedAmount;
      this.calculateSumOfBlend();
    },

    cleanInput(amount) {
      const removeUnwantedCharacters = amount.toString().replace(/[^\d.]/g, '');
      const firstDotIndex = removeUnwantedCharacters.indexOf('.');
      const withoutExtraDots = firstDotIndex >= 0
        ? removeUnwantedCharacters.slice(0, firstDotIndex + 1) +
        removeUnwantedCharacters.slice(firstDotIndex + 1).replace(/\./g, '')
        : removeUnwantedCharacters;

      // If only a dot is present or if the value ends with a dot, return as is
      if (withoutExtraDots === "." || withoutExtraDots.endsWith(".")) return withoutExtraDots;

      const roundTwoDecimalPlaces = withoutExtraDots.indexOf(".") >= 0
        ? (withoutExtraDots.substr(0, withoutExtraDots.indexOf(".")) + withoutExtraDots.substr(withoutExtraDots.indexOf("."), 3))
        : withoutExtraDots;

      const parsedValue = parseFloat(roundTwoDecimalPlaces);
      return isNaN(parsedValue) ? "" : parsedValue;
    },

    async generateDocumentRational() {
      this.isButtonLoading = true;
      this.$store.dispatch("WordDocs/getRational", { id: this.id, recipeName: this.recipeName }).then(() => {
        this.isButtonLoading = false;
      });
    },

    async generateDocumentSDS() {
      this.isButtonLoading = true;
      this.$store.dispatch("WordDocs/getSDS", { id: this.id, recipeName: this.recipeName }).then(() => {
        this.isButtonLoading = false;
      });
    },

    async generateDocumentLabel() {
      console.log('recipeName', this.recipeName)
      this.isButtonLoading = true;
      this.$store.dispatch("WordDocs/getLabel", { id: this.id, recipeName: this.recipeName }).then(() => {
        this.isButtonLoading = false;
      });
    },

    getDetailsByComponentName(componentName) {
      return this.classificationData.find(item => item.component_Name === componentName) || {};
    },

    calculateSumOfBlend() {
      let total = 0;
      for (const value of this.selectedTags) {
        let concentration = this.concentrations[value];

        if (concentration == null || concentration === "") {
          continue;
        }

        let parsedConcentration = parseFloat(concentration);
        if (!isNaN(parsedConcentration)) {
          total += parsedConcentration;
        }
      }

      this.sumOfBlend = total;
      this.calculateDerivedOralValue();
      this.calculateDerivedDermalValue();
      this.calculateDerivedInhaleValue();
    },


    calculateDermalSum() {
      let dermalSum = 0;

      for (const value of this.selectedTags) {
        let valueArray = this.getDetailsByComponentName(value);
        let concentration = this.concentrations[value];
        if (valueArray.dermalCalc != 0 && !isNaN(concentration)) {
          dermalSum += concentration / valueArray.dermalCalc;
        }
      }

      this.ateMixDermal = dermalSum.toFixed(6);
      return dermalSum.toFixed(6);
    },

    calculateOralSum() {
      let oralSum = 0;

      for (const value of this.selectedTags) {
        let valueArray = this.getDetailsByComponentName(value);
        let concentration = this.concentrations[value];
        if (valueArray.oralCalc != 0 && !isNaN(concentration)) { // Make sure you handle non-zero values
          oralSum += concentration / valueArray.oralCalc;
        }
      }
      this.ateMixOral = oralSum.toFixed(6);
      return oralSum.toFixed(6);
    },

    calculateInhaleSum() {
      let inhaleSum = 0;

      for (const value of this.selectedTags) {
        let valueArray = this.getDetailsByComponentName(value);
        let concentration = this.concentrations[value];
        if (valueArray.inhalationCalc != 0 && !isNaN(concentration)) { // Make sure you handle non-zero values
          inhaleSum += concentration / valueArray.inhalationCalc;
        }
      }
      console.log(inhaleSum);
      this.ateMixInhalation = inhaleSum.toFixed(6);
      return inhaleSum.toFixed(6);
    },

    calculateDerivedDermalValue() {
      const dermalSum = this.calculateDermalSum(); // Calculate dermalSum
      let fillerPercentage = 0;
      let derivedValue = 0;

      // Find the filler index
      const fillerIndex = this.selectedTags.findIndex(item => item === "FILLER");

      if (fillerIndex != -1) {
        fillerPercentage = this.getDetailsByComponentName("FILLER").percentage;
      }

      if (dermalSum != 0 && !isNaN(dermalSum)) {
        derivedValue = (100 - (isNaN(parseFloat(fillerPercentage)) ? 0 : parseFloat(fillerPercentage))) / dermalSum;
      }

      this.totalATEMixDermal = derivedValue.toFixed(6);
    },

    calculateDerivedOralValue() {
      const oralSum = this.calculateOralSum(); // Calculate dermalSum
      let fillerPercentage = 0;
      let derivedValue = 0;

      // Find the filler index
      const fillerIndex = this.selectedTags.findIndex(item => item === "FILLER");

      if (fillerIndex != -1) {
        fillerPercentage = this.getDetailsByComponentName("FILLER").percentage;
      }

      if (oralSum != 0 && !isNaN(oralSum)) {
        derivedValue = (100 - (isNaN(parseFloat(fillerPercentage)) ? 0 : parseFloat(fillerPercentage))) / oralSum;
      }

      this.totalATEMixOral = derivedValue.toFixed(6);
    },

    calculateDerivedInhaleValue() {
      const inhaleSum = this.calculateInhaleSum(); // Calculate dermalSum
      let fillerPercentage = 0;
      let derivedValue = 0;

      // Find the filler index
      const fillerIndex = this.selectedTags.findIndex(item => item === "FILLER");

      if (fillerIndex != -1) {
        fillerPercentage = this.getDetailsByComponentName("FILLER").percentage;
      }

      if (inhaleSum != 0 && !isNaN(inhaleSum)) {
        derivedValue = (100 - (isNaN(parseFloat(fillerPercentage)) ? 0 : parseFloat(fillerPercentage))) / inhaleSum;
      }

      this.totalATEMixInhalation = derivedValue.toFixed(6);
    },

    updateRecipe() {
      this.isLoading = true;
      let classificationsArray = [];

      for (let key in this.selectedTags) {
        let classificationInfo = this.getDetailsByComponentName(this.selectedTags[key]);
        let classificationId = classificationInfo['id'];
        let classificationName = classificationInfo['component_Name'];
        let concentration = this.concentrations[classificationInfo['component_Name']];
        let classificationData = {
          classificationId: classificationId,
          classificationName: classificationName,
          concentration: concentration
        };
        classificationsArray.push(classificationData);
      }

      let dataArray = [{
        recipeName: this.recipeName,
        createdBy: this.createdBy,
        customerId: this.customerId,
        ateMixOral: this.ateMixOral,
        totalATEMixOral: this.totalATEMixOral,
        ateMixDermal: this.ateMixDermal,
        totalATEMixDermal: this.totalATEMixDermal,
        ateMixInhalation: this.ateMixInhalation,
        totalATEMixInhalation: this.totalATEMixInhalation,
        sumOfBlend: this.sumOfBlend,
        classifications: classificationsArray
      }]

      this.$store.dispatch("recipes/updateRecipe", { id: this.id, data: dataArray[0] }).then(() => {
        if (this.RecipeUpdateStatus.success) {
          this.isLoading = false;
        } else {
          this.$router.push('/dashboards');
        }

      });
    },

    // Handles input validation after submission.
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values);
        }
      });
    },

    // Move step by a distance.
    moveStep(distance) {
      this.step += distance;
    },
    total(el) {
      return el.qu * el.price
    }

  },
  computed: {
    classifications: {
      get() {
        return this.$store.state.classifications.classifications;
      }
    },
    Customers: {
      get() {
        return this.$store.state.Customers.Customers;
      }
    },
    Recipe: {
      get() {
        return this.$store.state.recipes.recipe;
      }
    },
    RecipeUpdateStatus: {
      get() {
        return this.$store.state.recipes.recipeUpdateStatus;
      }
    }
  },
  created() {
    this.isLoading = true;
    this.id = isNaN(parseInt(this.$route.params.id)) ? splitURL[splitURLLength - 1] : this.$route.params.id
    this.$store.dispatch('recipes/getRecipe', this.id).then(() => {
      let waitForElement = (elementId, callback) => {
        let element = document.getElementById(elementId);
        if (element) {
          callback(element);
        } else {
          setTimeout(() => waitForElement(elementId, callback), 300);
        }
      };

      let recipeData = this.Recipe;
      let classifications = recipeData["classifications"];
      for (let classificationKey in classifications) {
        let classification = classifications[classificationKey];
        let classificationName = classification["classificationName"];
        this.selectedTags.push(classificationName);
        this.$set(this.concentrations, classificationName, classification["concentration"]);
      }

      this.recipeId = this.id;
      this.recipeName = recipeData.recipeName;
      this.createdBy = recipeData.createdBy;
      this.customerId = recipeData.customerId;
      this.ateMixOral = recipeData.ateMixOral;
      this.totalATEMixOral = recipeData.totalATEMixOral;
      this.ateMixDermal = recipeData.ateMixDermal;
      this.totalATEMixDermal = recipeData.totalATEMixDermal;
      this.ateMixInhalation = recipeData.ateMixInhalation;
      this.totalATEMixInhalation = recipeData.totalATEMixInhalation;
      this.sumOfBlend = recipeData.sumOfBlend;
      this.calculateSumOfBlend();
      this.isLoading = false;
    });

    this.$store.dispatch('classifications/getAll').then((res) => {
      this.classificationData = this.classifications;
    }).catch(error => {
      console.error(error)
    })

    this.$store.dispatch('Customers/getAll').then(() => {
      this.customerData = this.Customers; // Use the computed property directly
    });
    // store.dispatch('transactions/getAll').then((res) => {
    //   transactions.value = res;
    //   console.log('data below')
    //   console.log(transactions)
    // }).catch(error => {
    //   console.error(error)
    // })

  }
}

</script>

<style lang="scss">
.avatar {
  width: 50px;
  height: 50px;
  margin-top: 10px;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.loading-icon {
  font-size: 3em;
}

.text-center {
  display: flex;
  justify-content: center; /* Center the button horizontally */
  align-items: center; /* Optional: Center the button vertically if needed */
}

</style>